import React from 'react';

import CommonImage from '@/components/CommonImage';

const PendingTask = () => {
	return (
		<div className="body-content pending-task-container bg-white">
			<div className="pending-task-main-wrapper d-flex">
				{/* Left Section - Main Content */}
				<div className="pending-task-left-section flex-grow-1">
					<div className="pending-task-header bg-white d-flex align-items-center justify-content-between">
						<div className="pending-task-summary">
							<p className="semibold-14 gray_dark_01">
								Total pending:<span className="gray_dark_01 ml-1">24</span>
								<span className="gray_dark_02 ml-1 regular-14 weight-400">
									| Today completed:
									<span className="ml-1">12</span>
								</span>
							</p>
						</div>
						<div className="pending-task-refresh">
							<span className="regular-14 gray_dark_02 weight-400 d-flex align-items-center cursor-pointer">
								<span className="mr-2">Refresh</span>
								<CommonImage src="/icons/load.svg" width={16} height={16} alt="Refresh" />
							</span>
						</div>
					</div>
					{/* Task Categories Grid */}
					<div className="task-categories d-grid gap-4 grid-columns-3 scroll-y-label">
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
					</div>
				</div>

				{/* Right Section - Mentions Sidebar */}
				<div className="pending-task-right-section notification-section">
					{/* Sidebar Header */}
					<div className="mentions-header bg-white d-flex align-items-center justify-content-between">
						<div className="mentions-title">
							<p className="semibold-14 gray_dark_01">
								@ Mentions:<span className="gray_dark_01 ml-1">24</span>
							</p>
						</div>
						<div className="mentions-filter d-flex">
							<a href="#" className="regular-14 gray_dark_02 mr-3 cursor-pointer">
								Read
							</a>
							<a href="#" className="regular-14 gray_dark_02 cursor-pointer">
								Unread
							</a>
						</div>
					</div>

					{/* Mentions List */}
					<div className="mentions-list notification-body scroll-y-label mt-0">
						<div className="single-notification">
							<div className="heading-information">
								<div className="title d-flex align-items-center">
									<div className="action-icon">
										<CommonImage
											src="/icons/notification/mention.svg"
											alt="action-icon"
											width={16}
											height={16}
											className="mr-2"
										/>
									</div>
									<p className="regular-14 gray_dark_01 weight-500">
										Mentioned you
										<span className="gray_dark_02 weight-400"> on </span>
										GT25-A0465
									</p>
								</div>
								<p className="regular-14 gray_dark_02 text-uppercase"></p>
							</div>
							<div className="notification-details-information">
								<div className="new-dot"></div>
								<div className="contents-with-image">
									<div className="left-half">
										<div className="text-content">
											<p className="regular-14 gray_dark_01 weight-500 mb-1">Touhid</p>
											<p className="regular-14 gray_dark_01">Created a product issue</p>
										</div>
									</div>
									<div className="images">
										<CommonImage
											src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/9/468/1757313053867_1c.jpeg"
											alt="style"
											className="single-image"
											loading="lazy"
										/>
									</div>
								</div>

								<div className="date-important-info d-flex justify-content-between align-items-center">
									<div className="date-info d-flex align-items-center">
										<p className="regular-12 gray_dark_02 mr-1">10 Sep AT 2:04 pm</p>
										<p className="regular-12 gray_dark_01 text-uppercase text-underline ml-2 read-unread-text">
											UNREAD
										</p>
									</div>

									<div className="important-info">
										<div className="important-flag">
											<CommonImage
												src="/icons/important-flag-gray.svg"
												alt="important"
												title="Important flag"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="single-notification">
							<div className="heading-information">
								<div className="title d-flex align-items-center">
									<div className="action-icon">
										<CommonImage
											src="/icons/notification/mention.svg"
											alt="action-icon"
											width={16}
											height={16}
											className="mr-2"
										/>
									</div>
									<p className="regular-14 gray_dark_01 weight-500">
										Mentioned you
										<span className="gray_dark_02 weight-400"> on </span>
										GT25-A0465
									</p>
								</div>
								<p className="regular-14 gray_dark_02 text-uppercase"></p>
							</div>
							<div className="notification-details-information">
								<div className="new-dot"></div>
								<div className="contents-with-image">
									<div className="left-half">
										<div className="text-content">
											<p className="regular-14 gray_dark_01 weight-500 mb-1">Touhid</p>
											<p className="regular-14 gray_dark_01">Created a product issue</p>
										</div>
									</div>
									<div className="images">
										<CommonImage
											src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/9/468/1757313053867_1c.jpeg"
											alt="style"
											className="single-image"
											loading="lazy"
										/>
									</div>
								</div>

								<div className="date-important-info d-flex justify-content-between align-items-center">
									<div className="date-info d-flex align-items-center">
										<p className="regular-12 gray_dark_02 mr-1">10 Sep AT 2:04 pm</p>
										<p className="regular-12 gray_dark_01 text-uppercase text-underline ml-2 read-unread-text">
											UNREAD
										</p>
									</div>

									<div className="important-info">
										<div className="important-flag">
											<CommonImage
												src="/icons/important-flag-gray.svg"
												alt="important"
												title="Important flag"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="single-notification">
							<div className="heading-information">
								<div className="title d-flex align-items-center">
									<div className="action-icon">
										<CommonImage
											src="/icons/notification/mention.svg"
											alt="action-icon"
											width={16}
											height={16}
											className="mr-2"
										/>
									</div>
									<p className="regular-14 gray_dark_01 weight-500">
										Mentioned you
										<span className="gray_dark_02 weight-400"> on </span>
										GT25-A0465
									</p>
								</div>
								<p className="regular-14 gray_dark_02 text-uppercase"></p>
							</div>
							<div className="notification-details-information">
								<div className="new-dot"></div>
								<div className="contents-with-image">
									<div className="left-half">
										<div className="text-content">
											<p className="regular-14 gray_dark_01 weight-500 mb-1">Touhid</p>
											<p className="regular-14 gray_dark_01">Created a product issue</p>
										</div>
									</div>
									<div className="images">
										<CommonImage
											src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/9/468/1757313053867_1c.jpeg"
											alt="style"
											className="single-image"
											loading="lazy"
										/>
									</div>
								</div>

								<div className="date-important-info d-flex justify-content-between align-items-center">
									<div className="date-info d-flex align-items-center">
										<p className="regular-12 gray_dark_02 mr-1">10 Sep AT 2:04 pm</p>
										<p className="regular-12 gray_dark_01 text-uppercase text-underline ml-2 read-unread-text">
											UNREAD
										</p>
									</div>

									<div className="important-info">
										<div className="important-flag">
											<CommonImage
												src="/icons/important-flag-gray.svg"
												alt="important"
												title="Important flag"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="single-notification">
							<div className="heading-information">
								<div className="title d-flex align-items-center">
									<div className="action-icon">
										<CommonImage
											src="/icons/notification/mention.svg"
											alt="action-icon"
											width={16}
											height={16}
											className="mr-2"
										/>
									</div>
									<p className="regular-14 gray_dark_01 weight-500">
										Mentioned you
										<span className="gray_dark_02 weight-400"> on </span>
										GT25-A0465
									</p>
								</div>
								<p className="regular-14 gray_dark_02 text-uppercase"></p>
							</div>
							<div className="notification-details-information">
								<div className="new-dot"></div>
								<div className="contents-with-image">
									<div className="left-half">
										<div className="text-content">
											<p className="regular-14 gray_dark_01 weight-500 mb-1">Touhid</p>
											<p className="regular-14 gray_dark_01">Created a product issue</p>
										</div>
									</div>
									<div className="images">
										<CommonImage
											src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/9/468/1757313053867_1c.jpeg"
											alt="style"
											className="single-image"
											loading="lazy"
										/>
									</div>
								</div>

								<div className="date-important-info d-flex justify-content-between align-items-center">
									<div className="date-info d-flex align-items-center">
										<p className="regular-12 gray_dark_02 mr-1">10 Sep AT 2:04 pm</p>
										<p className="regular-12 gray_dark_01 text-uppercase text-underline ml-2 read-unread-text">
											UNREAD
										</p>
									</div>

									<div className="important-info">
										<div className="important-flag">
											<CommonImage
												src="/icons/important-flag-gray.svg"
												alt="important"
												title="Important flag"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="single-notification">
							<div className="heading-information">
								<div className="title d-flex align-items-center">
									<div className="action-icon">
										<CommonImage
											src="/icons/notification/mention.svg"
											alt="action-icon"
											width={16}
											height={16}
											className="mr-2"
										/>
									</div>
									<p className="regular-14 gray_dark_01 weight-500">
										Mentioned you
										<span className="gray_dark_02 weight-400"> on </span>
										GT25-A0465
									</p>
								</div>
								<p className="regular-14 gray_dark_02 text-uppercase"></p>
							</div>
							<div className="notification-details-information">
								<div className="new-dot"></div>
								<div className="contents-with-image">
									<div className="left-half">
										<div className="text-content">
											<p className="regular-14 gray_dark_01 weight-500 mb-1">Touhid</p>
											<p className="regular-14 gray_dark_01">Created a product issue</p>
										</div>
									</div>
									<div className="images">
										<CommonImage
											src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/9/468/1757313053867_1c.jpeg"
											alt="style"
											className="single-image"
											loading="lazy"
										/>
									</div>
								</div>

								<div className="date-important-info d-flex justify-content-between align-items-center">
									<div className="date-info d-flex align-items-center">
										<p className="regular-12 gray_dark_02 mr-1">10 Sep AT 2:04 pm</p>
										<p className="regular-12 gray_dark_01 text-uppercase text-underline ml-2 read-unread-text">
											UNREAD
										</p>
									</div>

									<div className="important-info">
										<div className="important-flag">
											<CommonImage
												src="/icons/important-flag-gray.svg"
												alt="important"
												title="Important flag"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="single-notification">
							<div className="heading-information">
								<div className="title d-flex align-items-center">
									<div className="action-icon">
										<CommonImage
											src="/icons/notification/mention.svg"
											alt="action-icon"
											width={16}
											height={16}
											className="mr-2"
										/>
									</div>
									<p className="regular-14 gray_dark_01 weight-500">
										Mentioned you
										<span className="gray_dark_02 weight-400"> on </span>
										GT25-A0465
									</p>
								</div>
								<p className="regular-14 gray_dark_02 text-uppercase"></p>
							</div>
							<div className="notification-details-information">
								<div className="new-dot"></div>
								<div className="contents-with-image">
									<div className="left-half">
										<div className="text-content">
											<p className="regular-14 gray_dark_01 weight-500 mb-1">Touhid</p>
											<p className="regular-14 gray_dark_01">Created a product issue</p>
										</div>
									</div>
									<div className="images">
										<CommonImage
											src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/9/468/1757313053867_1c.jpeg"
											alt="style"
											className="single-image"
											loading="lazy"
										/>
									</div>
								</div>

								<div className="date-important-info d-flex justify-content-between align-items-center">
									<div className="date-info d-flex align-items-center">
										<p className="regular-12 gray_dark_02 mr-1">10 Sep AT 2:04 pm</p>
										<p className="regular-12 gray_dark_01 text-uppercase text-underline ml-2 read-unread-text">
											UNREAD
										</p>
									</div>

									<div className="important-info">
										<div className="important-flag">
											<CommonImage
												src="/icons/important-flag-gray.svg"
												alt="important"
												title="Important flag"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="single-notification">
							<div className="heading-information">
								<div className="title d-flex align-items-center">
									<div className="action-icon">
										<CommonImage
											src="/icons/notification/mention.svg"
											alt="action-icon"
											width={16}
											height={16}
											className="mr-2"
										/>
									</div>
									<p className="regular-14 gray_dark_01 weight-500">
										Mentioned you
										<span className="gray_dark_02 weight-400"> on </span>
										GT25-A0465
									</p>
								</div>
								<p className="regular-14 gray_dark_02 text-uppercase"></p>
							</div>
							<div className="notification-details-information">
								<div className="new-dot"></div>
								<div className="contents-with-image">
									<div className="left-half">
										<div className="text-content">
											<p className="regular-14 gray_dark_01 weight-500 mb-1">Touhid</p>
											<p className="regular-14 gray_dark_01">Created a product issue</p>
										</div>
									</div>
									<div className="images">
										<CommonImage
											src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/9/468/1757313053867_1c.jpeg"
											alt="style"
											className="single-image"
											loading="lazy"
										/>
									</div>
								</div>

								<div className="date-important-info d-flex justify-content-between align-items-center">
									<div className="date-info d-flex align-items-center">
										<p className="regular-12 gray_dark_02 mr-1">10 Sep AT 2:04 pm</p>
										<p className="regular-12 gray_dark_01 text-uppercase text-underline ml-2 read-unread-text">
											UNREAD
										</p>
									</div>

									<div className="important-info">
										<div className="important-flag">
											<CommonImage
												src="/icons/important-flag-gray.svg"
												alt="important"
												title="Important flag"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="single-notification">
							<div className="heading-information">
								<div className="title d-flex align-items-center">
									<div className="action-icon">
										<CommonImage
											src="/icons/notification/mention.svg"
											alt="action-icon"
											width={16}
											height={16}
											className="mr-2"
										/>
									</div>
									<p className="regular-14 gray_dark_01 weight-500">
										Mentioned you
										<span className="gray_dark_02 weight-400"> on </span>
										GT25-A0465
									</p>
								</div>
								<p className="regular-14 gray_dark_02 text-uppercase"></p>
							</div>
							<div className="notification-details-information">
								<div className="new-dot"></div>
								<div className="contents-with-image">
									<div className="left-half">
										<div className="text-content">
											<p className="regular-14 gray_dark_01 weight-500 mb-1">Touhid</p>
											<p className="regular-14 gray_dark_01">Created a product issue</p>
										</div>
									</div>
									<div className="images">
										<CommonImage
											src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/9/468/1757313053867_1c.jpeg"
											alt="style"
											className="single-image"
											loading="lazy"
										/>
									</div>
								</div>

								<div className="date-important-info d-flex justify-content-between align-items-center">
									<div className="date-info d-flex align-items-center">
										<p className="regular-12 gray_dark_02 mr-1">10 Sep AT 2:04 pm</p>
										<p className="regular-12 gray_dark_01 text-uppercase text-underline ml-2 read-unread-text">
											UNREAD
										</p>
									</div>

									<div className="important-info">
										<div className="important-flag">
											<CommonImage
												src="/icons/important-flag-gray.svg"
												alt="important"
												title="Important flag"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="single-notification">
							<div className="heading-information">
								<div className="title d-flex align-items-center">
									<div className="action-icon">
										<CommonImage
											src="/icons/notification/mention.svg"
											alt="action-icon"
											width={16}
											height={16}
											className="mr-2"
										/>
									</div>
									<p className="regular-14 gray_dark_01 weight-500">
										Mentioned you
										<span className="gray_dark_02 weight-400"> on </span>
										GT25-A0465
									</p>
								</div>
								<p className="regular-14 gray_dark_02 text-uppercase"></p>
							</div>
							<div className="notification-details-information">
								<div className="new-dot"></div>
								<div className="contents-with-image">
									<div className="left-half">
										<div className="text-content">
											<p className="regular-14 gray_dark_01 weight-500 mb-1">Touhid</p>
											<p className="regular-14 gray_dark_01">Created a product issue</p>
										</div>
									</div>
									<div className="images">
										<CommonImage
											src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/9/468/1757313053867_1c.jpeg"
											alt="style"
											className="single-image"
											loading="lazy"
										/>
									</div>
								</div>

								<div className="date-important-info d-flex justify-content-between align-items-center">
									<div className="date-info d-flex align-items-center">
										<p className="regular-12 gray_dark_02 mr-1">10 Sep AT 2:04 pm</p>
										<p className="regular-12 gray_dark_01 text-uppercase text-underline ml-2 read-unread-text">
											UNREAD
										</p>
									</div>

									<div className="important-info">
										<div className="important-flag">
											<CommonImage
												src="/icons/important-flag-gray.svg"
												alt="important"
												title="Important flag"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="other-tasks-section mt-3">
				<div className="other-tasks-header bg-white">
					<div className="navigation-tab bg-white">
						<ul>
							<li className="active">
								<a href="#">Others pending task</a>
							</li>
							<li></li>
						</ul>
					</div>
				</div>
				<div className="other-tasks-body p-3 d-flex justify-content-between align-items-center">
					{/* It should be "expanded" here. */}
					<div className="other-tasks-content w-100 expanded">
						<div className="d-grid gap-4 grid-columns-4">
							<div className="task-category-card shadow-2dp">
								<div
									className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
									style={{ backgroundColor: '#EFF6FF' }}
								>
									<div className="d-flex align-items-center">
										<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
										<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
											Sample development
										</p>
									</div>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle"
												type="button"
												id="menu1"
												data-toggle="dropdown"
											>
												<CommonImage
													src="/icons/more_vertical.svg"
													alt="more_icon"
													width={24}
													height={24}
												/>
											</button>
											<ul className="dropdown-menu dropdown-menu-right shadow-lg">
												<li className="px-4 pb-3 pt-3">
													<a className="font-weight-normal text-black">Edit</a>
												</li>
												<li className="px-4 pb-3">
													<a className="font-weight-normal text-black">Delete</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="task-category-body">
									<ul className="task-list">
										<li className="regular-14 gray_dark_01 mb-2 cursor-none">
											Need your sample review <span className="gray_dark_01">(20)</span>
										</li>
										<li className="regular-14 gray_dark_01 mb-2">
											Send to buyer <span className="gray_dark_01">(45)</span>
										</li>
										<li className="regular-14 gray_dark_01">
											Buyer sample review <span className="gray_dark_01">(23)</span>
										</li>
									</ul>
								</div>
								<div className="view-more d-flex align-items-center cursor-pointer mt-2">
									<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
										View <span>4</span> more
									</p>
									<CommonImage
										className="arrow-icon"
										src="/icons/down-arrow-gray-dark-01.svg"
										width={20}
										height={20}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="collaps-btn cursor-pointer">
						<CommonImage src="/icons/angel-bottom.svg" width={16} height={16} className="mr-2" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default PendingTask;
